import React, { useState } from 'react';

const Users = () => {
    const [users, setUsers] = useState([
        { id: 1, name: 'Иван Иванов', login: 'ivanov', role: 'Администратор' },
        { id: 2, name: 'Петр Петров', login: 'petrov', role: 'Пользователь' },
        { id: 3, name: 'Мария Сидорова', login: 'sidorova', role: 'Редактор' }
    ]);

    const handleDeleteUser = (userId) => {
        setUsers(users.filter(user => user.id !== userId));
    };

    return (
        <div>
            <h2>Пользователи</h2>

            <div className="table">
                <div className="table__row table__row_header">
                    <div className="table__cell">Имя</div>
                    <div className="table__cell">Логин</div>
                    <div className="table__cell">Роль</div>
                    <div className="table__cell">Действия</div>
                </div>

                {users.map(user => (
                    <div key={user.id} className="table__row">
                        <div className="table__cell">
                            <span className="table__cell_text">{user.name}</span>
                        </div>
                        <div className="table__cell">
                            <span className="table__cell_text">{user.login}</span>
                        </div>
                        <div className="table__cell">
                            <span className="table__cell_text">{user.role}</span>
                        </div>
                        <div className="table__cell">
                            <button className="button" style={{ marginRight: '0.5rem' }}>
                                Редактировать
                            </button>
                            <button
                                className="button button-danger"
                                onClick={() => handleDeleteUser(user.id)}
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="add-section">
                <button className="button">Добавить пользователя</button>
            </div>
        </div>
    );
};

export default Users;